<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import { useLessonCustomerTimezone } from '../../model/lessons/lesson-customer-timezone.hook'

defineOptions({
  name: 'LessonCustomerTimezone',
})

const {
  refTimezone,
  refTime,
} = useLessonCustomerTimezone()
</script>

<template>
  <div
    v-if="refTimezone"
    class="lesson-customer-timezone"
  >
    <AppText
      name="body2-medium"
      color="slate-900"
    >
      Customer timezone:
    </AppText>
    <AppText
      name="body2"
      color="slate-900"
    >
      {{ refTime }}
    </AppText>
    <AppText
      name="body2"
      color="slate-900"
    >
      {{ refTimezone }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./LessonCustomerTimezone.scss" />
